<template>
    <v-container v-resize="onResize">
        <statistical-header :title="title"></statistical-header>
        <loader v-if="loading" />
        <template v-if="!loading">
            
            <v-radio-group v-if="!loading" style="position:absolute; margin-top: 40px; z-index: 999; left: 50%;margin-left: -120px;" 
                v-model="womenInMinistriesDataType" row>
               
                <v-radio label="Percentage" value="percentage"></v-radio>
                 <v-radio label="Count" value="number"></v-radio>
            </v-radio-group>
            <chart v-if="!loading" :chartData="womenInMinistries" />

            <br/>

            <v-layout row wrap align-center>
                <v-flex xs12 offset-md8 md4>
                    <v-text-field v-if="!this.loading" v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
                </v-flex>
            </v-layout>

                  <br/>
            
            <v-menu v-if="this.isMobile" d-inline offset-y :nudge-left="140" :close-on-content-click="true">
                <v-btn outline small slot="activator">
                    Sort <v-icon>sort</v-icon>
                </v-btn>
                <v-list>
                        <v-subheader
                        >
                        Sort by:
                        </v-subheader>
                    <v-list-tile v-for="(item, index) in HEADERS.filter(h => h.text != '' && h.sortable != false)" :key="item.value" @click="changeSort(item.value)">
                        <v-list-tile-title>
                            {{ item.text }}
                            <v-icon v-if="PAGINATION.sortBy === item.value">{{PAGINATION.descending ? 'arrow_downward':'arrow_upward'}}</v-icon>
                        </v-list-tile-title>
                    </v-list-tile>
                </v-list>
            </v-menu>
            <v-data-table :items="MINISTRYRECORDS"
                        :headers="HEADERS"
                        :rows-per-page-items="ROWS_LISTITEMS"
                        v-on:update:pagination="UPDATE_PAGINATION"
                        :pagination.sync="PAGINATION"
                        :hide-headers="isMobile"
                        :class="{ mobileDataTable: isMobile, 'elevation-1': true }"
                        :search="search"
                        disable-initial-sort>

                <template v-slot:items="props">
                    <template v-if="isMobile">
                        <tr>
                            <td>
                                <div class="flex-content">
                                    
                                    <div class="flex-item flex-item-col flex-item-col-30">
                                        <div class="flex-item">
                                            <Portrait v-bind:PHID="props.item.PHID" :fixedWidth="80"></Portrait>
                                        </div>
                                    </div>
                                    <div class="flex-item flex-item-col flex-item-col-70">
                                        <div class="flex-item">
                                            <h3><router-link :to="{ name: $store.state.ROUTE_PARLIAMENTARIAN, params: { PHID: props.item.PHID }}">{{ props.item.DisplayName }}</router-link></h3>
                                        </div>
                                        <div class="flex-item" data-label="Ministry">
                                            {{ props.item.Ministry }}
                                        </div>
                                    </div>
                                    <div class="flex-item" data-label="Portfolio">
                                        <div style="white-space: break-spaces;">{{ props.item.FullRoleDate }}</div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </template>
                    <router-link v-else class="tr handbook-tablerow_link" :to="{ name: $store.state.ROUTE_PARLIAMENTARIAN, params: { PHID: props.item.PHID }}" >
                        <td class="text-xs-left"><Portrait v-bind:PHID="props.item.PHID" :fixedWidth="80"></Portrait></td>
                        <td class="text-xs-left">{{ props.item.DisplayName }}</td>
                        <td class="text-xs-left handbook-tablecol_linebreaks">{{ props.item.Ministry }}</td>
                        <td class="text-xs-left handbook-tablecol_linebreaks" style="white-space: break-spaces;">{{ props.item.FullRole }}</td>
                        <td class="text-xs-left handbook-tablecol_linebreaks">{{ props.item.DateStart }}</td>
                        <td class="text-xs-left handbook-tablecol_linebreaks">{{ props.item.DateEnd }}</td>
                    </router-link>
                </template>

                <template v-slot:no-results>
                    <v-alert :value="true" color="error" icon="warning">
                        Your search for "{{ search }}" found no results.
                    </v-alert>
                </template>
            </v-data-table>
                   <br />
        </template>
    </v-container>
</template>
<script>
import Loader from '@/components/Loader.vue';
import StatisticalHeader from './StatisticalHeader.vue';
import Chart from './Chart.vue';
import axios from 'axios';
 import Portrait from '@/components/Portrait.vue'
import _ from 'lodash';
import moment from 'moment'

window.Handbook = window.Handbook || {}
const apiUri = window.Handbook.ApiUri || "https://localhandbookapi.aph.gov.au/";
axios.defaults.baseURL = apiUri;

export default {
    created() {
        this.initialiseItems();
    },
    components: {
        Loader,
        StatisticalHeader,
        Chart,
        Portrait
    },
    methods: {
        
        initialiseItems() {
            this.loading = true;
            const parliamentarianType = this.selectedMpOrSenator.length == 0 || this.selectedMpOrSenator.length == 2 ?
                '' : this.selectedMpOrSenator[0];

            var ministriesLoading = true;
            var ministryRecordsLoading = true;

            const url = `StatisticalInformation/Ministries?parliamentariantype=${parliamentarianType}`;
            axios.get(`api/${url}`)
                .then(response => {
                    this.MINISTRIES = response.data;
                    ministriesLoading = false;

                    if (!ministriesLoading && !ministryRecordsLoading){
                        this.loading = false;
                    }
                });

            const recordUrl = `ministryrecords?$filter=Gender%20eq%20%27Female%27`;
            axios.get(`api/${recordUrl}`)
                .then(response => {
                    this.MINISTRYRECORDSList = response.data.value;
                    ministryRecordsLoading = false;

                    if (!ministriesLoading && !ministryRecordsLoading){
                        this.loading = false;
                    }
                });

        },
        filterMpOrSenator() {
            this.initialiseItems();
        },
        UPDATE_PAGINATION: function (options) {
            this.$gtag.event("committees by name pagination items per page", {
                event_category: "filters",
                event_label: `items per page: ${options.rowsPerPage}`,
                value: 1,
            });
            this.$gtag.event("committees by name pagination page", {
                event_category: "filters",
                event_label: `page: ${options.page}`,
                value: 1,
            });
            this.$gtag.event(`committees by name sorting`, {
                event_category: "sorting",
                event_label: `sort by ${options.sortBy} ${
                options.descending ? "DESC" : "ASC"
                }`,
                value: 1,
            });
            return this.PAGINATION;
        },
        stringDate (value) {
            if (value && value != 'undefined' && value != 'Undefined' 
            && value != '1900-01-01' 
            && value != '1900-01-01T00:00:00Z' 
            && value != '1900-01-1' 
            && value != '0001-01-01'
            && value != '0001-01-01T00:00:00Z') {
                var dateDMY = moment(String(value));
                if (dateDMY.isValid()){
                    return dateDMY.format('DD/MM/YYYY');
                }
                else {
                    var dateFormat =  moment(String(value), 'YYYY-DD-MM');
                    if (dateFormat.isValid()){
                        return dateFormat.format('DD/MM/YYYY');
                    }
                    else {
                        return ''
                    }
                }
            } else {
                return 'present'
            }
        },
        onResize() {
            if (window.innerWidth < 769){
                this.isMobile = true;
            }
            else{
                this.isMobile = false;
            }
        },
        changeSort(column) {
            if (this.PAGINATION.sortBy === column) {
                this.PAGINATION.descending = !this.PAGINATION.descending
            } 
            else {
                this.PAGINATION.sortBy = column
                this.PAGINATION.descending = false
            }
        }
    }, 
    computed: {
           
            womenInMinistries() {
                const series = [ 'Women Ministers', 'Women Cabinet Ministers']
                    .map(h => ({
                    name: h,
                    data: []
                }));

                const categories = [];
                var data = this.MINISTRIES.filter(m => m.Id >= 24);
                var maxYAxisVal = 0;

                data.forEach(d => {
                    categories.push(d.MinistryName);
                    const womenMinisters = series[0];
                    const womenCabinetMinisters = series[1];

                    if (d.WomenMinisters > 0 || d.WomenCabinetMinisters > 0){
                        if (maxYAxisVal < this.womenInMinistriesDataType == "percentage" ? (d.WomenMinisters/d.Ministers)*100 : d.WomenMinisters){
                            maxYAxisVal = this.womenInMinistriesDataType == "percentage" ? (d.WomenMinisters/d.Ministers)*100 : d.WomenMinisters;
                        }
                        womenMinisters.data.push({
                            name: d.MinistryName,
                            leaderPHID: d.LeaderPHID,
                            dateString: this.stringDate(d.DateStart)  + ' - ' + this.stringDate(d.DateEnd),
                            valToShow: this.womenInMinistriesDataType,
                            y: this.womenInMinistriesDataType == "percentage" ? (d.WomenMinisters/d.Ministers)*100 : d.WomenMinisters,
                            yCount: d.WomenMinisters,
                            yPercentage: (d.WomenMinisters/d.Ministers)*100,
                            yTotal: d.Ministers
                        });
                        
                        womenCabinetMinisters.data.push({
                            name: d.MinistryName,
                            dateString: this.stringDate(d.DateStart)  + ' - ' + this.stringDate(d.DateEnd),
                            leaderPHID: d.LeaderPHID,
                            valToShow: this.womenInMinistriesDataType,
                            y: this.womenInMinistriesDataType == "percentage" ? (d.WomenCabinetMinisters/d.CabinetMinisters)*100 : d.WomenCabinetMinisters,
                            yCount: d.WomenCabinetMinisters,
                            yPercentage: (d.WomenCabinetMinisters/d.CabinetMinisters)*100,
                            yTotal: d.CabinetMinisters
                        });
                    }
                    else {
                        if (maxYAxisVal < d.WomenMinisters){
                            maxYAxisVal = d.WomenMinisters;
                        }
                        womenMinisters.data.push({
                            name: d.MinistryName,
                            dateString: this.stringDate(d.DateStart)  + ' - ' + this.stringDate(d.DateEnd),
                            leaderPHID: d.LeaderPHID,
                            valToShow: this.womenInMinistriesDataType,
                            y: this.womenInMinistriesDataType == "percentage" ? (d.WomenMinisters/d.Ministers)*100 : d.WomenMinisters,
                            yCount: 0,
                            yPercentage: 0,
                            yTotal: d.Ministers
                        });
                      
                        womenCabinetMinisters.data.push({
                            name: d.MinistryName,
                            dateString: this.stringDate(d.DateStart)  + ' - ' + this.stringDate(d.DateEnd),
                            leaderPHID: d.LeaderPHID,
                            valToShow: this.womenInMinistriesDataType,
                            y: this.womenInMinistriesDataType == "percentage" ? (d.WomenCabinetMinisters/d.CabinetMinisters)*100 : d.WomenCabinetMinisters,
                            yCount: 0,
                            yPercentage: 0,
                            yTotal: d.CabinetMinisters
                        });
                    }
                });

                return {
                    chart: {
                        type: 'line',
                        height: 600,
                        marginBottom: 180,
                    },
                    title: {
                        text: "Women in Cabinet and Ministries"
                    },
                    accessibility: {
                        point: {
                            valueDescriptionFormat: this.womenInMinistriesDataType == "percentage" ? 
                            '{index}. {point.category}, {point.y}%.' 
                            : '{index}. {point.category}, {point.y}.'
                        }
                    },
                    xAxis: {
                        categories: categories,
                        title: {
                            text: 'Ministries'
                        },
                        plotLines: [{
                            color: '#ddd',
                            width: 2,
                            value: 7
                        }, {
                            color: '#ddd',
                            width: 2,
                            value: 1
                        }],
                         labels: {
                            style: {
                                textOverflow: 'none'
                            }
                        } 
                    },
                    yAxis: {
                        labels: {
                            formatter: function () {
                                return this.value;
                            }
                        },
                        title: {
                            text: this.womenInMinistriesDataType == "percentage" ? 'Percentage (%)' : 'Total count'
                        }
                    },
                    exporting: {
                        filename: 'Women in Cabinet and Ministries',
                        sourceWidth: 1200
                    },
                    tooltip: {
                        shared: true,
                        split: false,
                        followPointer: false,
                        borderWidth: 0,
                        backgroundColor: 'transparent',
                        shadow: false,
                        formatter: function () {
                           var points = this.points;
                            var pointsLength = points.length;
                            var tooltipMarkup = pointsLength ? '<div style="display:inline-block"><img src="https://www.aph.gov.au/api/parliamentarian/' 
                            + points[0].point.leaderPHID  
                            + '/image" style="width: 80px;border-radius: 5px;"></img></div><div style="display:inline-block; padding-left:10px;">' 
                            + '<span style="font-size:1.1em;font-weight:bold;">' + points[0].key + '</span><br />' 
                            + '<span>' + points[0].point.dateString + '</span>'
                            + '<br/><br/>' : '';
                            var index;
                            for (index = 0; index < pointsLength; index += 1) {
                                tooltipMarkup += '<span style="color:' + points[index].series.color + '">\u25CF</span> ' + points[index].series.name + ': <b>' 
                                    + (points[index].point.valToShow == "percentage" ? parseFloat(points[index].point.yPercentage).toFixed(1) 
                                    + '%</b><br/>&nbsp;(' + points[index].point.yCount + '/' + points[index].point.yTotal + ' total ' + points[index].series.name.replace('Women','') + ')'
                                    :  points[index].point.yCount
                                    + '</b><br/>&nbsp;(' + parseFloat(points[index].point.yPercentage).toFixed(1) +'%, '+ points[index].point.yCount + '/' + points[index].point.yTotal + ' total ' + points[index].series.name.replace('Women','') + ')') 
                                    + '<br/>' ;
                            }
                            return '<div class="tooltip">' + tooltipMarkup +'</div></div>';
                        },    
                        useHTML: true,
                    },
                    plotOptions: {
                        area: {
                            lineColor: '#ffffff',
                            lineWidth: 1,
                            marker: {
                                lineWidth: 1,
                                lineColor: '#ffffff'
                            }
                        },
                        series: {
                            stickyTracking: false
                        }
                    },
                    annotations: [{
                        labels: [{
                            point: {
                                x: 7,
                                xAxis:0,
                                y: this.isMobile ? 70 : 0,
                                yAxis: maxYAxisVal/2
                            },
                            allowOverlap: true,
                            align: 'left',
                            text: 'All Ministers served<br>as Cabinet Ministers <br>until 1956'
                        },
                        {
                            point: {
                                x: 1,
                                xAxis:0,
                                y: this.isMobile ? 25 : 0,
                                yAxis: maxYAxisVal/2
                            },
                            align: 'left',
                            allowOverlap: true,
                            text: 'First women elected<br>to Parliament<br>21/08/1943'
                        }],
                        draggable: '',
                        zIndex: 999,
                        labelOptions: {
                            backgroundColor: 'rgba(255,255,255,0.5)',
                            borderColor: 'silver'
                        }
                    }],
                    series
                }
            },
            MINISTRYRECORDS: function () {
                if (this.loading) {
                    return []
                }
                var ministry = this.MINISTRYRECORDSList.map(m => ({ ...m, FullRoleDate: '', FullRole: `${m.Role}${m.Prep !== '' ? ` ${m.Prep} ${m.Entity}` : ''}` }));

                var consolidatedMinistry = [];
               
                let first = undefined;
                let aggregateRole = undefined;
                let aggregateRoleWithDate = undefined;
                let aggregateDateStart = undefined;
                let aggregateDateEnd = undefined;
                for (let i = 0; i < ministry.length; i++) {
                    var isValidToShowCabinetMinister = true;
                    let isCabinetMinister = ministry[i].FullRole === 'Cabinet Minister';
                    let showMinister = (!isCabinetMinister || isCabinetMinister && isValidToShowCabinetMinister);
                    if (showMinister) {
                        if (!first) {
                            first = ministry[i];
                            aggregateRole = first.FullRole;
                            aggregateRoleWithDate = first.FullRole + " (" + this.formatDate(first.RDateStart, null, null, false) + " - " + this.formatDate(first.RDateEnd, null, null, false) + ")";
                            aggregateDateStart = this.formatDate(first.RDateStart, null, null, false);
                            aggregateDateEnd = this.formatDate(first.RDateEnd, null, null, false);
                        } else {
                            if (i === ministry.length - 1) {
                                if (first.PHID !== ministry[i].PHID) {
                                    let lastmin = { ...first, FullRole: aggregateRole, FullRoleDate: aggregateRoleWithDate, DateStart: aggregateDateStart, DateEnd: aggregateDateEnd };
                                    consolidatedMinistry.push(lastmin);
                                    first = ministry[i];
                                    aggregateRole = first.FullRole;
                                    aggregateRoleWithDate = first.FullRole + " (" + this.formatDate(first.RDateStart, null, null, false) + " - " + this.formatDate(first.RDateEnd, null, null, false) + ")";
                                    aggregateDateStart = this.formatDate(first.RDateStart, null, null, false);
                                    aggregateDateEnd = this.formatDate(first.RDateEnd, null, null, false);

                                    //push current instance
                                    consolidatedMinistry.push({ ...ministry[i], FullRole: aggregateRole, FullRoleDate: aggregateRoleWithDate, DateStart: aggregateDateStart, DateEnd: aggregateDateEnd });

                                } else {
                                    if (!aggregateRole.includes(ministry[i].FullRole)) {
                                        aggregateRole = `${aggregateRole}\n${ministry[i].FullRole}`;
                                        aggregateRoleWithDate = `${aggregateRoleWithDate}\n${ministry[i].FullRole}` + " (" + `${this.formatDate(ministry[i].RDateStart, null, null, false)}` + " - " + `${this.formatDate(ministry[i].RDateEnd, null, null, false)}`;
                                        aggregateDateStart = `${aggregateDateStart}\n${this.formatDate(ministry[i].RDateStart, null, null, false)}`;
                                        aggregateDateEnd = `${aggregateDateEnd}\n${this.formatDate(ministry[i].RDateEnd, null, null, false)}`;
                                    }
                                    consolidatedMinistry.push({ ...first, FullRole: aggregateRole, FullRoleDate: aggregateRoleWithDate, DateStart: aggregateDateStart, DateEnd: aggregateDateEnd });
                                }
                            } else {
                                if (first.PHID !== ministry[i].PHID) {
                                    let min = { ...first, FullRole: aggregateRole, FullRoleDate: aggregateRoleWithDate, DateStart: aggregateDateStart, DateEnd: aggregateDateEnd };
                                    consolidatedMinistry.push(min);
                                    first = ministry[i];
                                    aggregateRole = first.FullRole;
                                    aggregateRoleWithDate = first.FullRole + " (" + this.formatDate(first.RDateStart, null, null, false) + " - " + this.formatDate(first.RDateEnd, null, null, false) + ")";
                                    aggregateDateStart = this.formatDate(first.RDateStart, null, null, false);
                                    aggregateDateEnd = this.formatDate(first.RDateEnd, null, null, false);
                                } else {
                                    if (!aggregateRole.includes(ministry[i].FullRole)) {
                                        aggregateRole = `${aggregateRole}\n${ministry[i].FullRole}`;
                                        aggregateRoleWithDate = `${aggregateRoleWithDate}\n${ministry[i].FullRole}` + " (" + `${this.formatDate(ministry[i].RDateStart, null, null, false)}` + " - " + `${this.formatDate(ministry[i].RDateEnd, null, null, false)}`;
                                        aggregateDateStart = `${aggregateDateStart}\n${this.formatDate(ministry[i].RDateStart, null, null, false)}`;
                                        aggregateDateEnd = `${aggregateDateEnd || ' '}\n${this.formatDate(ministry[i].RDateEnd, null, null, false) || ' '}`;
                                    }
                                }
                            }
                        }
                    } else {
                        if (i === ministry.length - 1) {
                            if (first) {
                                if (first.PHID !== ministry[i].PHID) {
                                    let lastmin = { ...first, FullRole: aggregateRole, FullRoleDate: aggregateRoleWithDate, DateStart: aggregateDateStart, DateEnd: aggregateDateEnd };
                                    consolidatedMinistry.push(lastmin);

                                } else {
                                    consolidatedMinistry.push({ ...first, FullRole: aggregateRole, FullRoleDate: aggregateRoleWithDate, DateStart: aggregateDateStart, DateEnd: aggregateDateEnd });
                                }
                            }
                        }
                    }
                }

                consolidatedMinistry = this._.orderBy(consolidatedMinistry, m => m.RDateStart)

                return consolidatedMinistry;
            },
    },
    mounted() {
        this.onResize();
    },
    watch: {
        selectedMpOrSenator: function () {
            this.initialiseItems();
        }
    },
    data() {
        return {
            title: 'Women in Ministries',
            isMobile: false,
            womenInMinistriesDataType: 'percentage',
            MINISTRIES: [],
            MINISTRYRECORDSList: [],
            search: '',
            loading: true,
            selectedMpOrSenator: ['senator', 'mp'],
            ROWS_LISTITEMS: [
                10,
                20,
                50,
                100,
                {
                text: "$vuetify.dataIterator.rowsPerPageAll",
                value: -1,
                },
            ],
            PAGINATION: {
                rowsPerPage: 50,
                sortBy: "WomenPercentage",
                descending: true
            },
        HEADERS: [
                {
                    text: '',
                    value: 'DisplayName',
                    align: 'left',
                    sortable: false,
                },
                {
                    text: 'Minister',
                    value: 'DisplayName',
                    align: 'left',
                    sortable: true,
                },
                {
                    text: 'Ministry',
                    value: 'Ministry',
                    align: 'left',
                    sortable: true,
                },
                {
                    text: 'Portfolio',
                    value: 'FullRole',
                    align: 'left',
                    sortable: true,

                },
                {
                    text: 'Start Date',
                    value: 'DateStart',
                    align: 'left',
                    sortable: true,

                }
                ,
                {
                    text: 'End Date',
                    value: 'DateEnd',
                    align: 'left',
                    sortable: true,

                }
            ],
        }
    }
}
</script>
<style >
.highcharts-tooltip span {
        left: 0px;
        top: 0px;
       border:none !important;
    }
.tooltip {
    position: relative;
    z-index: 50;
    border: 1px solid rgb(0, 108, 169) !important;
    border-radius: 5px;
    background-color: #ffffff;
    padding: 5px;
    font-size: 9pt;
}
</style>
<style lang="stylus" scoped>

    .v-input--radio-group >>> .v-label {
            color: rgb(14, 21, 49);
    }
    
     .highcharts-container {
    overflow: visible !important;
  }

  .highcharts-container svg {
    overflow: visible !important;
  }

    td.handbook-tablecol_linebreaks {
        white-space: pre;
    }

    tr.handbook-tablerow_link {
        cursor: pointer;
    }

    .v-datatable .tr {
        display:table-row;
    }

    .v-datatable a.tr {
        color: #0e1531de;
        text-decoration:none;
        border: 1px solid #dbdbdb;
        border-left: none;
        border-right: none;
    }

    .v-datatable tbody td {
        vertical-align: middle;
    }
</style>